import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import PreventParentClickWrapper from 'ui-library/wrappers/PreventParentClickWrapper';
import {ElementMouseEvent} from 'util/Types';

interface StarIconProps {
  onClick: (e: ElementMouseEvent) => void;
  starred?: boolean;
}

export default function StarIcon(props: StarIconProps): JSX.Element {
  return (
    <PreventParentClickWrapper>
      <BenchlingIcon
        className={classNames('starIcon', css(styles.starIconButton), {
          'starIcon--outline': !props.starred,
        })}
        onClick={props.onClick}
        icon={props.starred ? 'star' : 'star-outline'}
      />
    </PreventParentClickWrapper>
  );
}

const styles = StyleSheet.create({
  starIconButton: {
    cursor: 'pointer',
  },
});
